import {
  CloseCircleOutlined,
  CommentOutlined,
  DeleteOutlined,
  EditFilled,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Tooltip,
  Typography,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { VideoApi } from "../../api/backend/video";
import Loading from "../../component/Desktop/loading/loading";
import { COMMON_CONSTANT, KEY, lang } from "../../constants/common.const";
import { handleCatchError, showMessage } from "../../constants/utils";
import classGrid from "../../models/control/grid";
import { formatNumber } from "../../utils/helper";
import "./view.scss";
import rolesConst from "../../routers/roles/roles.const";
import { ShowMoreText } from "../../component/Text/showMoreText";
const { Text, Title } = Typography;

const VideoCustomComment = ({
  author,
  content,
  time,
  isMine,
  userName,
  commentId,
  callback = () => {},
  setIsDirty,
  isDelete,
  avatarUrl
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [text, setText] = useState(content);
  const { id } = useParams();
  const { userName:userId,roleKey,roles } = useSelector((state) => state.auth);
   const isLead =
      roles === rolesConst.HEAD_OFFICE_ADMIN || roles === rolesConst.OFFICE_ADMIN;
  let [showLoading, setShowLoading] = useState(false);
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };

  const handleCancel = () => {
    setText(content);
    setIsEdit(false);
    setIsDirty(false)
  };
  const handleSave = async () => {
    try {
      openLoadingSpinner()
      await VideoApi.updateVideoComment({
        videoId: id,
        comment: text,
        userName:userId,
        id:commentId
      });
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, async () => {
        setIsEdit(false);
        callback();
        setIsDirty(false)

      });
    } catch (error) {
      handleCatchError(true);
    }finally{
      closeLoadingSpinner()
    }
  };
  function confirmSaveData() {
    Modal.confirm({
      centered: true,
      title: lang.CONFIRM,
      content: COMMON_CONSTANT.BOM_C009,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      icon: <QuestionCircleOutlined />,
      onOk: () => {
        handleSave();
      },
      onCancel: () => {},
    });
  }
 
  const showMessageDeleteConfirm = (rowData) => {
    // Action del
    const funcDel = async () => {
      openLoadingSpinner();

      // API Del
      try {
        // Close warning
        Modal.destroyAll();

        await VideoApi.deleteVideoComment(commentId);
        // Open success
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004, () => callback());
      } catch (ex) {
        handleCatchError(ex);
      }
      closeLoadingSpinner();
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.DELETE,
      content: "削除してもよろしいですか？",
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
      zIndex: 10000,
    });
  };
  return (
    <div className="video-comment">
      <Avatar src={avatarUrl} size={"large"} className="video-comment-avatar">
        {author.charAt(0).toUpperCase()}
      </Avatar>
      <div className="video-comment-body">
        <div
          className="video-comment-header"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <Text className="video-comment-author" strong>
            {`${author}(${userName})`}
          </Text>
          <Text
            className="video-comment-time"
            style={{ fontSize: 12, color: "#999", marginTop: -3 }}
            type="secondary"
          >
            {time}
          </Text>
        </div>
        <div
          className="video-comment-content"
          style={{ whiteSpace: "pre-line" }}
        >
          {!isEdit ? (
            <ShowMoreText text={text} />
          ) : (
            <div>
              <TextArea
                onChange={(e) => {
                  setIsDirty(true)
                  setText(e.target.value)
                }}
                rows={4}
                value={text}
              />
              <div className="mt5 right">
                <Button
                style={{
                  height:35
                }}
                disabled={!String(text || "").trim()}
                  className={`button ${String(text || "").trim()?"button--info" : ""} wAuto mr10`}
                  onClick={() => confirmSaveData()}
                >
                  <SaveOutlined />
                  {lang.SAVE}
                </Button>
                <Button
                  className="buttonPC button--outline --todo-- wAuto"
                  key={2}
                  onClick={() => {
                    handleCancel();
                  }}
                >
                  <CloseCircleOutlined />
                  {lang.CANCEL}
                </Button>
                ,
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        
        className="video-comment-actions"
      >
        <Tooltip title={lang.EDIT}>
          <EditFilled
            onClick={() => setIsEdit(true)}
            style={{
              fontSize: 16,
              cursor: "pointer",
              marginLeft: 10,
              marginRight: 10,
             visibility: (!isMine || isEdit) && "hidden",
              color: "#0080cb",
            }}
            className=""
          />
        </Tooltip>

        {/* Delete */}
        <Tooltip title={lang.DELETE}>
          <DeleteOutlined
            onClick={showMessageDeleteConfirm}
            style={{
              fontSize: 16,
              cursor: "pointer",

              color: "red",
              visibility: (!isDelete || isEdit) && "hidden",
            }}
            className=""
          />
        </Tooltip>
      </div>
      <Loading show={showLoading} />
    </div>
  );
};

const VideoComments = ({setIsDirty}) => {
  const { id } = useParams();
  const [listComment, setListComment] = useState(new classGrid());
  const { userName } = useSelector((state) => state.auth);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const getListComment = async () => {
    try {
      const res = await VideoApi.getVideoComments({ id });
      const data = (res.data || []).map((comment) => ({
        createTime:comment.createTime,
        commentId: comment.id,
        author: comment.displayName || comment.updateId,
        content: comment.comment,
        isMine: comment.userName == userName,
        userName: comment.userName,
        isDelete:comment.isDelete,
        avatarUrl:comment.avatarUrl,
        time: comment.updateDatetime? moment().diff(moment(comment.updateDatetime), 'seconds') < 10
    ? "数秒前"
    : moment(comment.updateDatetime).fromNow()
  : "",
      }));
      setListComment({
        ...listComment,
        data :data.sort(
          (a, b) => new Date(b.createTime) - new Date(a.createTime)
        ),
      });
    } catch (error) {
      // handleCatchError(error);
    }
  };
  useEffect(() => {
    if (id) {
      getListComment();
    }
  }, [id]);

  const saveComment = async () => {
    try {
      setLoading(true);
      const body = {
        videoId: id,
        comment: text,
        userName,
      };
      await VideoApi.createVideoComment(body);
      setText("");
      getListComment();
      setIsDirty(false)
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      paddingInline:0
    }} className="video-comments">
      <Title level={5}>
        {formatNumber(listComment.data.length)} 件のコメント
      </Title>
      <Input.TextArea
        value={text}
        onChange={(e) => {
          setText(e.target.value)
          setIsDirty(true)
        }}
        rows={4}
        placeholder="コメントを入力してください..."
        className="video-comment-input"
      />
      <Row
        style={{
          marginTop: -10,
          marginBottom: 20,
        }}
      >
        <Col className="right" span={24}>
          <div>
            <Button
              onClick={saveComment}
              disabled={!String(text || "").trim()}
              icon={<CommentOutlined />}
              className={`button ${String(text || "").trim()?"button--info" : ""} wAuto`}
            >
              {lang.SAVE}
            </Button>
          </div>
        </Col>
      </Row>
      <div className="video-comment-list">
        {listComment.data.map((comment, idx) => (
          <VideoCustomComment
            setIsDirty={setIsDirty}
            callback={getListComment}
            count={listComment.data.length}
            key={comment.commentId}
            {...comment}
          />
        ))}
      </div>
      <Loading show={loading} />
    </div>
  );
};

export default VideoComments;
